// components/ImageUpload.js

import React, { useEffect, useState } from 'react';
import { AddLogoImage,GetLogoImage,AddDrInfo,ADDTEMPLATESETTING,GetDoctorInfo,DeleteDrInfo} from '../Services/Template';
import SpinnerModal from '../Spinner/SpinnerModal';
import { toast } from 'react-toastify';
import DeleteForeverRoundedIcon from '@mui/icons-material/DeleteForeverRounded';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import CheckIcon from '@mui/icons-material/Check';
import Slide from '@mui/material/Slide';
import '../UI/TemplateModal.css'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  tableCellClasses,
  Divider, 
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from '@mui/material';
import { Paper } from '@mui/material';
import { styled } from '@mui/material/styles';
import Modal from 'react-bootstrap/Modal';
import Editor from './Editor/Editor';
import CustomTemp from './Editor/CustomeTemp';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#2c6bd7',
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  const transitionDuration = 500; // milliseconds
  return <Slide direction="down" ref={ref} {...props} timeout={transitionDuration} />;
});

const TemplateSetting = () => {
  const [isLoading, setIsLoading] = useState(false); 
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [image,seImage] = useState(null);
  const [TEMPValue, setTEMPValue] = useState('');
  const [DRINFOData,SetDRData] = useState([]);
    const [lgShow, setLgShows] = useState(false);
  const[isDelete,SetisDelete] = useState(false);
  const [DrID,setDRID] = useState([]);
  const [isDeleteSuccess,SetIsDeleteSuccess] = useState(false);
  const [boxBorderColor, setBoxBorderColor] = useState('lightgray'); 

    const handleFileChange = (e) => {
      
        const file = e.target.files[0];
        setSelectedFile(file);
        const reader = new FileReader();
        reader.onloadend = () => {
          setPreviewImage(reader.result);
          const img = new Image();
           img.src = reader.result;
          img.onload = () => {
            const imgWidth = img.width;
            if (imgWidth > 650) {
              setBoxBorderColor('#56ea56');
            } else {
              setBoxBorderColor('red');
            }
            setPreviewImage(reader.result);
          };
        };
        reader.readAsDataURL(file);
    };


    const handleChange = (event) => {
      setTEMPValue(event.target.value);
    };

    const handleUpload = async (e) => {
      e.preventDefault();
      setIsLoading(true)
        try {
            
            const formData = new FormData();
           
            formData.append('file', selectedFile);
            formData.append('LabID', sessionStorage.getItem('LabID'));
            formData.append('TEMP',TEMPValue)
            const response = await AddLogoImage(formData);
            if(response){
              toast.success("Template Selected")
            }
           } catch (error) {
            toast.error('Error uploading image:', error);
           }
           finally{
           setIsLoading(false)
           }
       };
//-----------Get image --------------
    const getimage = async() =>{
      try{
        setIsLoading(true);
        const LabID = sessionStorage.getItem('LabID')
        const result  = await GetLogoImage(LabID)
        seImage(result)
        setTEMPValue(result?.[0]?.selectedTemplate) 
      }catch(error){
        toast.error('Error Load data:', error);
      }finally{
        setIsLoading(false)
      }
    }
//------------------END------------

//-----------Use Effect--------
useEffect(() =>{
  getimage();
},[])

//-----------------End--------
//---------- Doctor information -----------
const [Drdata,setDrdata] = useState({
  drname:'',
  designation:'',
  description:'',
  address:'',
  LaboratoryID: sessionStorage.getItem('LabID')
})

const onChange = (e) =>{
  const {name,value} = e.target;
    setDrdata({
      ...Drdata,
      [name]:value
    })

}

const Submit = (e) =>{
  e.preventDefault();
  setIsLoading(true)
  try{
    if(Drdata.drname == '' || Drdata.designation == '' || Drdata.description == '' ){
      toast.warning('Please add doctor necessary information ')
    }else{
      const response = AddDrInfo(Drdata);
      if(response != null ){
       toast.success('Doctore info saved successfully')
       SetIsDeleteSuccess(true);
      }
    }
     
  }catch(error){
    console.log("something went wrong",error)
    toast.error(error)
  }finally{
    setIsLoading(false)
  }
  
}
//------------------GetDRinfo--------------
const  GetDRInfo = async () =>{
  try{
    setIsLoading(true);
    const LabID = sessionStorage.getItem('LabID')
    const result  = await GetDoctorInfo(LabID)
    SetDRData(result);
    SetIsDeleteSuccess(false);
  }catch(error){
    toast.error('Error Load data:', error);
  }finally{
    setIsLoading(false)
  }
}
useEffect(() =>{
  GetDRInfo();
},[isDeleteSuccess])
//----------End-----------------
//--------------font data set--------------
const FONTFAMILY = [
  {
    value:' sans-serif',
    label:'Helvetica'
  },
  {
    value:'sans-serif;',
    label:'Arial'
  },
  {
    value:'serif',
    label:'Times New Roman'
  },
  {
    value:'Georgia serif',
    label:'Georgia '
  },
  {
    value:'monospace',
    label:'Courier '
  },
  {
    value:'fantasy',
    label:'Luminari'
  },
  {
    value:'cursive',
    label:'cursive'
  },
  {
    value:'system-ui',
    label:'system-ui'
  },
]
const FONTSIZE = [
  {
    value:'10px',
    label:'2xs'
  },
  {
    value:'12px',
    label:'xs'
  },
  {
    value:'14px',
    label:'sm'
  }, 
  {
    value:'16px',
    label:'md'
  }, 
  {
    value:'18px',
    label:'lg'
  },
  {
    value:'20px',
    label:'xl'
  }
]
const [FONTSDATA,SETFONTSDATA] = useState({
  fontfamily:'',
  fontsize:'',
  LabID: sessionStorage.getItem('LabID')
})

const onChangeFONTS = (e) =>{
  const {name,value} = e.target;
  SETFONTSDATA({
      ...FONTSDATA,
      [name]:value
    })
}
const  saveFontsSetting = ()=>{
  setIsLoading(true)
  try{
       var res = ADDTEMPLATESETTING(FONTSDATA);
       if(res != null){
         toast.success('Fonts Updated ')
       }
  }catch (error){
    toast.error(error)
  }finally{
    setIsLoading(false)
  }
}
//------------END--------------
//----------------delete Dr Info------
const handleDelete = (id) =>{
  setDRID(id);
  if(id){
    SetisDelete(true)
   }else{
    SetisDelete(false)
  }
}
const DeleteDRInfos = () =>{
  try{
   
   setIsLoading(true)
      const LabID = sessionStorage.getItem('LabID');
       var res = DeleteDrInfo(LabID,DrID)   
       if(res){
         toast.success("Doctor Info Deleted!");
         SetIsDeleteSuccess(true);
       }   
  }
  catch(error){
      toast.error(error)
  }finally{
    SetisDelete(false);
    setIsLoading(false)
  }
}
//-----------------END
//--------handle colosed-------
const handleClose = () =>{
  SetisDelete(false)
}
//---------end------

//----------------------Hande image from Editor-------
const handleEditorImage = (imageBase64) => {
  setPreviewImage(imageBase64);

  const blob = dataURLtoBlob(imageBase64);
  const file = new File([blob], 'editor-image.png', { type: 'image/png' });

  setSelectedFile(file);
};

// Helper function
function dataURLtoBlob(dataUrl) {
  const arr = dataUrl.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while(n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
}

    return (
      <>
{isLoading && <SpinnerModal isLoading={true} />}
 <div className='container-fluid Container2'>
    <div className='common-box-shadow common-bg-white common-br-3px' style={{padding:'10px'}}>
     <form  onSubmit={handleUpload}>
      <div className="form-check">
        <input 
          value="1" 
          className="form-check-input" 
          type="radio" 
          name="flexRadioDefault" 
          id="header-logotemplate" 
          checked={TEMPValue === '1'} 
          onChange={handleChange}
        />
        <label className="common-FontSize-small common-FontFamily"  htmlFor="header-logotemplate">
          Standard Header Template
        </label>
      </div>
      <div className="form-check">
        <input 
          value="2" 
          className="form-check-input" 
          type="radio" 
          name="flexRadioDefault" 
          id="Premium-Template" 
          checked={TEMPValue === '2'} 
          onChange={handleChange}
        />
        <label className="common-FontSize-small common-FontFamily" htmlFor="Premium-Template">
           Premium Professional Template
        </label>  
      </div>
      <div className="form-check">
        <input 
          value="3" 
          className="form-check-input" 
          type="radio" 
          name="flexRadioDefault" 
          id="simple-template" 
          checked={TEMPValue === '3'} 
          onChange={handleChange}
        />
        <label className="common-FontSize-small common-FontFamily" htmlFor="simple-template">
          Minimal Report Template
        </label>
      </div>
      <div className="form-check">
        <input 
          value="4" 
          className="form-check-input" 
          type="radio" 
          name="flexRadioDefault" 
          id="T4" 
          checked={TEMPValue === '4'} 
          onChange={handleChange}
        />
        <label className="common-FontSize-small common-FontFamily" htmlFor="T4">
          Modern Clinical Template  
        </label>  
      </div>
       <div className="form-check">
        <input 
          value="5" 
          className="form-check-input" 
          type="radio" 
          name="flexRadioDefault" 
          id="T5" 
          checked={TEMPValue === '5'} 
          onChange={handleChange}
        />
        <label className="common-FontSize-small common-FontFamily" htmlFor="T5">
          Executive Report Template
        </label>  
      </div>
         <div>
          <span style={{color:`${boxBorderColor}`}} className='common-FontSize-small common-FontFamily'>Note: If the size of uploaded pics not fit in the given box it may show stretch </span>
               <div style={{border:`1px solid ${boxBorderColor}` ,width:'820px'}}>
                {previewImage ? (
                  <img 
                    src={previewImage}
                    alt='Selected'
                    style={{ maxWidth: '100%', maxHeight: '130px', height: '130px',}}
                  />
                  )
                :(
                  <img 
                  src={"data:image/png;base64," + image?.[0]?.data} 
                  alt='Selected' 
                  style={{ maxWidth: '100%', maxHeight: '130px', height: '130px', }} />
                )
                }

               </div> 
               <div className='file-button'>
                  <input  type="file" onChange={handleFileChange} />
                  
                  <Button  type='submit'   variant="contained" className="common-button" >Update</Button>       
                  <Button  type='button' onClick={() => setLgShows(true)}   variant="contained" className="common-button" >Design Template</Button>                               

               </div> 
         </div>
           </form>    
    </div>
     <div className='d-flex'>
        <div className='col-6 common-box-shadow common-bg-white common-br-3px' style={{padding:'10px',marginTop:'10px' }}>
        <h5 className="common-FontSize-small common-FontFamily">Note: Select your desire Font Family and Size</h5>
        <hr></hr>
        <div className="row">
            <div className='col-sm-4'>
              <label className='common-Labels' htmlFor="FONTFAMILY">Font Family</label>
            </div>
            <div className='col-sm-6'>
            <select
                    className="form-select  common-Input"
                    id='FONTFAMILY'
                    name='fontfamily'
                    required
                    onChange={onChangeFONTS}
                    value={FONTSDATA.fontfamily}
                    >
                    {FONTFAMILY.map((option) => (
                    <option key={option.value} value={option.value}>
                    {option.label}
                    </option>
                    ))}
                  </select>
            </div>
           
            <div className='col-sm-4'>
                <label className='common-Labels' htmlFor="FONTSIZE">Font Zise</label>
            </div>
            <div className='col-sm-6 mt-2'>
                <select
                      className="form-select  common-Input"
                      id='FONTSIZE'
                      name='fontsize'
                      required
                      onChange={onChangeFONTS}
                      value={FONTSDATA.fontsize}
                      >
                      {FONTSIZE.map((option) => (
                      <option key={option.value} value={option.value}>
                      {option.label}
                      </option>
                      ))}
                  </select>
              </div>
              </div>
              <div style={{marginTop:'5px'}}>
                <Button  type='button'onClick={saveFontsSetting}   variant="contained" className="common-button" >Update</Button>
              </div>
        </div>
      </div>  
    <div className='row justify-content-between p-3'>
      <div className='common-box-shadow common-bg-white common-br-3px'>
          <div  style={{ padding:'10px',marginTop:'10px' }}>
          <h5 className="common-FontSize-small common-FontFamily">Note:Add Doctor Info for Premium Template .</h5>
            <hr></hr>
            <div className="row">
              <div className="col-sm-6">  
                 <label className='common-Labels' htmlFor="drname">DR. Name:</label>
                <input
                  className="form-control form-control common-Input"
                  id='drname'
                  name='drname'
                  onChange={onChange}
                  value={Drdata.drname}
                  required
                />
              </div>
              <div className="col-sm-6 "> 
                 <label className='common-Labels' htmlFor="designation">Designation:</label>
                <input
                  className="form-control form-control common-Input"
                  id='designation'
                  name='designation'
                  onChange={onChange}
                  value={Drdata.designation}
                  required
                />
              </div>
              <div className="col-sm-6 ">
                <label className='common-Labels' htmlFor="description">Description:</label>
                <input
                  className="form-control form-control common-Input"
                  id='description'
                  name='description'
                  onChange={onChange}
                  value={Drdata.description}       
                  required       
                />
              </div>
              <div className="col-sm-6 ">
                  <label className='common-Labels' htmlFor="address">Address:</label>
                <input
                  className="form-control form-control common-Input"
                  id='address'
                  name='address'
                  onChange={onChange}
                  value={Drdata.address}
                />
              </div>
            </div>
            <div className="row">
              <div className='col-sm-3 mt-4'>
                <Button type='button' onClick={Submit}  variant="contained" className="common-button" >Save</Button>
              </div>
            </div>
        </div>
    
       <div style={{ padding:'10px',marginTop:'10px' }}>
        <Table  stickyHeader aria-label="sticky table" >
                <TableHead>
                    <StyledTableRow>
                        <StyledTableCell className='DTC1'>Dr Name</StyledTableCell>
                        <StyledTableCell className='DTC1'>Designation</StyledTableCell>
                        <StyledTableCell className='DTC1'>Description</StyledTableCell>
                        <StyledTableCell className='DTC1'>Action  </StyledTableCell>

                    </StyledTableRow>
                </TableHead>
                <TableBody>  
                        {DRINFOData.map((data, index) => (
                        <StyledTableRow  key={index}>
                          <StyledTableCell className='DTC'>{data.drname} </StyledTableCell>
                          <StyledTableCell className='DTC'>{data.designation}</StyledTableCell>
                          <StyledTableCell className='DTC'>{data.description}</StyledTableCell>
                          <StyledTableCell className='DTC'>
                            <Button  onClick={() => handleDelete(data.drid)} type='button'   variant="contained" className="Delete-Action-Button" >Delete</Button>
                          </StyledTableCell> 
                        </StyledTableRow>
                        ))}
                </TableBody>
        </Table>
        </div>
      </div>
       
    </div>

    <div>
                <Dialog PaperProps={{ style: { borderRadius:'0px',padding:'10px'},}} open={isDelete} keepMounted onClose={handleClose} className='common-modal'  TransitionComponent={Transition}>
                  <div style={{textAlign:'end'}}>
                    <button className='common-cross-button' onClick={handleClose}>
                      <CloseRoundedIcon />
                    </button>
                  </div>
                        <DialogTitle style={{textAlign:'center'}} className='common-FontFamily'>
                          <CancelOutlinedIcon style={{fontSize:'100px',color:'red'}}/><br></br>
                          <h4>Are you sure!</h4>
                        </DialogTitle>
                        <DialogContent>
                          <DialogContentText id="alert-dialog-slide-description">
                            <span>  Do you really want to delete these record?</span><br></br>
                            <span> This proccess cannot be undone.</span> 
                          </DialogContentText>
                        </DialogContent>
                        <DialogActions sx={{textAlign:'center',display:'block'}}>
                           <Button  onClick={handleClose}variant="contained" type='button' className=" dialog-Cancel-button">Cancel</Button>
                          <Button  onClick={DeleteDRInfos} variant="contained" type='button' className=" dialog-Delete-button">Delete</Button>
                                        
                        </DialogActions>
                </Dialog>
    </div> 
  </div>

           <div>
              <Modal size="xl" show={lgShow}  dialogClassName="modal-90w" aria-labelledby="example-custom-modal-styling-title">
                <Modal.Header className='d-flex align-center justify-content-between'>
                  <Modal.Title className='d-flex align-center'>
                  </Modal.Title>
                     <div>
                       {/* <button className="Model-check" onClick={() => setLgShows(false)}> <CheckIcon /></button> */}
                       <button className="Model-Cross" onClick={() => setLgShows(false)}> <CloseRoundedIcon  /></button>
                    </div>
                </Modal.Header>
                <Modal.Body>
                   <div>
                    <Editor  onPreviewGenerated={handleEditorImage}/>
                  </div>
                  {/* <div>
                    <CustomTemp/>
                    </div> */}
                </Modal.Body>
              </Modal>
           </div>
 </>
       
    );
};

export default TemplateSetting;
